import {
  ReactNode,
  useEffect,
  useState,
} from 'react'

import { cn } from '@/lib/utils'

export interface SegmentedOption<Value> {
  value: Value
  label: ReactNode
}

export interface SegmentedProps<Value> {
  options: SegmentedOption<Value>[]
  value: Value
  onChange: (value: Value) => void
  className?: string
  indicatorClassName?: string
}

export default function Segmented<Value>({
  options,
  value,
  onChange,
  indicatorClassName,
  className = '',
}: SegmentedProps<Value>) {
  const [indicatorStyle, setIndicatorStyle] = useState({})

  useEffect(() => {
    const index = options.findIndex(option => option.value === value)

    setIndicatorStyle({
      width: `${100 / options.length}%`,
      transform: `translateX(${index * 100}%)`,
    })
  }, [options, value])

  return (
    <div
      className={cn(
        'bg-white/8 rounded-[0.625rem] p-1',
        className,
      )}
    >
      <div className="relative flex items-center">
        <div
          className={cn(
            'absolute h-full',
            'bg-primary rounded-lg',
            'transition-all duration-300 ease-in-out',
            indicatorClassName,
          )}
          style={indicatorStyle}
        />
        {options.map((option) => (
          <div
            key={String(option.value)}
            className={`
            cursor-pointer flex-1 py-1 text-center
            font-semibold z-10
            transition-colors duration-300
            ${value === option.value ? 'text-white' : 'text-secondary-foreground hover:text-foreground'}
          `}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </div>
        ))}
      </div>
    </div>
  )
}
